//import FindCGWordPopup from "@/pages/comp/plan/todo/popup/find_cg_word";
import TextBookFindSimpleListArea from "@/pages/comp/book_order/textbook/common/find_simple";
import FindWordInsidePopup from "@/pages/comp/plan/word/word_inside/popup/find_list";

function FindCGWordPopup(props: any) {
  let myProps = {
    par_sort: "mtextbook",//word_inside
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    is_req_order: true,
    xcolumn_show_key_arr: [],
    ...props
  };

  return (
    <div>
      {myProps.par_sort == "mtextbook" &&
        <TextBookFindSimpleListArea
          closePopup={myProps.closePopup}
          refreshData={myProps.refreshData}
          callbackData={myProps.callbackData}
          listOpt={myProps.listOpt}
          is_req_order={myProps.is_req_order}
          xcolumn_show_key_arr={myProps.xcolumn_show_key_arr}
        ></TextBookFindSimpleListArea>
      }
      {myProps.par_sort == "word_inside" &&
        <FindWordInsidePopup
          closePopup={myProps.closePopup}
          refreshData={myProps.refreshData}
          callbackData={myProps.callbackData}
        ></FindWordInsidePopup>
      }
    </div>
  );
};
export default FindCGWordPopup;